<div (click)="isGroupExpanded = !isGroupExpanded">
  <i class="fa-solid me-2" [ngClass]="!!isGroupExpanded ? 'fa-minus' : 'fa-plus'"></i><strong>{{group}} ({{items.length}})</strong>
</div>
@if (isGroupExpanded) {
  <div class="ms-2 mb-1">
    @for (item of items | orderBy: 'Name'; track item) {
      <div class="ms-1">
        <strong>{{item.Name}}</strong>
      </div>
      <ul>
        <li><strong>Asset Tag:</strong> {{item.AssetTag}}</li>
        <li><strong>Manufacturer:</strong> {{item.Manufacturer}}</li>
        <li><strong>Model:</strong> {{item.Model}}</li>
        <li><strong>Location:</strong> {{item.Site}}</li>
      </ul>
    }
  </div>
}
